"use client";

import React from "react";
import { ArrowRight, Maximize2, Truck, Zap } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const planningItems = [{
  title: "Electrical Demands",
  icon: Zap,
  text: "Used machinery does not remove the need for proper site planning. Before purchasing, confirm the electrical requirements for the exact bull, controller and blower."
}, {
  title: "Operating Footprint",
  icon: Maximize2,
  text: "Also check the full operating footprint. The mechanical base is only one part of the setup; the inflatable safety area and surrounding clearance may require considerably more room."
}, {
  title: "Transit & Access",
  icon: Truck,
  text: "If the bull will move between events, also consider packed dimensions, vehicle access and how the equipment will be loaded and unloaded."
}];
export default function Planning() {
  const shouldReduceMotion = useReducedMotion();
  const containerVariants = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: shouldReduceMotion ? 0 : 0.06
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 12
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.3,
        ease: [0.16, 1, 0.3, 1]
      }
    }
  };
  return <section id="powerandspaceplanning" data-nav="light" className="border-b border-border bg-background py-16 text-foreground md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header Block with Datum Styling */}
        <div className="mb-12 border-b border-border pb-8 md:mb-16">
          <h2 className="font-serif text-3xl font-bold tracking-tight uppercase sm:text-4xl md:text-5xl">
            Check Power and Space Before You Buy
          </h2>
        </div>

        {/* 3 Industrial Cards Grid */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        amount: 0.2
      }} className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {planningItems.map((item, i) => {
          const Icon = item.icon;
          return <motion.article key={item.title} data-index={i} variants={itemVariants} className="group flex flex-col justify-between border border-border bg-card p-6 shadow-xs transition-[border-color] duration-150 hover:border-foreground/80 md:p-8">
                <div>
                  {/* Spec Plate Header */}
                  <div className="mb-6 flex items-center justify-end border-b border-border pb-4">
                    <div className="border border-border bg-muted/60 p-2 text-foreground">
                      <Icon className="size-4" />
                    </div>
                  </div>

                  {/* Card Title */}
                  <h3 className="font-serif text-xl font-bold uppercase tracking-tight sm:text-2xl">
                    {item.title}
                  </h3>

                  {/* Body Text */}
                  <p className="mt-4 text-sm leading-relaxed text-muted-foreground md:text-base">
                    {item.text}
                  </p>
                </div>
              </motion.article>;
        })}
        </motion.div>

        {/* Bottom CTA Area */}
        <div className="mt-12 border-t border-border pt-8">
          <Button asChild size="lg" className="rounded-none bg-primary px-8 text-primary-foreground shadow-xs transition-colors hover:bg-primary/90">
            <Link to="/SetupSafetyAndMaintenancePage" className="inline-flex items-center gap-2 font-mono text-xs font-semibold uppercase tracking-wider">
              <span>View Setup & Safety Information</span>
              <ArrowRight className="size-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}